export default function getAlias(node) {
    switch (node) {
        case "PF":
            return "功率因数"
        case "PFa":
            return "A相功率因数"
        case "PFb":
            return "B相功率因数"
        case "PFc":
            return "C相功率因数"
        case "PA":
            return "有功功率"
        case "PAa":
            return "A相有功功率"
        case "PAb":
            return "B相有功功率"
        case "PAc":
            return "C相有功功率"
        case "PR":
            return "无功功率"
        case "PRa":
            return "A相无功功率"
        case "PRb":
            return "B相无功功率"
        case "PRc":
            return "C相无功功率"
        case "P":
            return "视在功率"
        case "Pa":
            return "A相视在功率"
        case "Pb":
            return "B相视在功率"
        case "Pc":
            return "C相视在功率"
        case "F":
            return "频率"
        case "Ua":
            return "A相相电压"
        case "Ub":
            return "B相相电压"
        case "Uc":
            return "C相相电压"
        case "Uab":
            return "A相线电压"
        case "Ubc":
            return "B相线电压"
        case "Uac":
            return "C相线电压"
        case "Ia":
            return "A相电流"
        case "Ib":
            return "B相电流"
        case "Ic":
            return "C相电流"
        case "THD_Ua":
            return "A相电压总谐波"
        case "THD_Ub":
            return "B相电压总谐波"
        case "THD_Uc":
            return "C相电压总谐波"
        case "THD_Ia":
            return "A相电流总谐波"
        case "THD_Ib":
            return "B相电流总谐波"
        case "THD_Ic":
            return "C相电流总谐波"
     
            // case "H_Ia_3":
        //     return "3次A相电流总谐波"
        // case "H_Ib_3":
        //     return "3次B相电流总谐波"
        // case "H_Ic_3":
        //     return "3次C相电流总谐波"
        // case "THD_Ia":
        //     return "A相电流总谐波"
        // case "THD_Ib":
        //     return "B相电流总谐波"
        // case "THD_Ic":
        //     return "C相电流总谐波"
        default:
            return node
    }
}